import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  clone: {
    id: 'studio.p2koFn',
    defaultMessage: 'Clone app',
  },
  error: {
    id: 'studio.GT6XtR',
    defaultMessage: 'There was a problem cloning the app. Please try again.',
  },
  name: {
    id: 'studio.HAlOn1',
    defaultMessage: 'Name',
  },
  nameDescription: {
    id: 'studio.ErKUoz',
    defaultMessage: 'The name of the app',
  },
  description: {
    id: 'studio.Q8Qw5B',
    defaultMessage: 'Description',
  },
  descriptionDescription: {
    id: 'studio.TgSTnd',
    defaultMessage: 'A short description of what the app can do.',
  },
  visibilityLabel: {
    id: 'studio.JAkIqb',
    defaultMessage: 'Visibility',
  },
  visibilityDescription: {
    id: 'studio.JMlZGy',
    defaultMessage:
      'Public apps are available in the app store. Unlisted apps aren’t listed publicly, but they are accessible using a direct link. Private apps are only visible to organization members.',
  },
  public: {
    id: 'studio.uhu5aG',
    defaultMessage: 'Public',
  },
  unlisted: {
    id: 'studio.HalL+U',
    defaultMessage: 'Unlisted',
  },
  private: {
    id: 'studio.viXE32',
    defaultMessage: 'Private',
  },
  organization: {
    id: 'studio.K56Dim',
    defaultMessage: 'Organization',
  },
  resources: {
    id: 'studio.c/KktL',
    defaultMessage: 'Resources',
  },
  resourcesDescription: {
    id: 'studio.ipgyGT',
    defaultMessage: 'Copy any resources that are allowed to be cloned.',
  },
  assets: {
    id: 'studio.d1uESJ',
    defaultMessage: 'Assets',
  },
  assetsDescription: {
    id: 'studio.7n6SLi',
    defaultMessage: 'Copy any assets that are allowed to be cloned.',
  },
  variables: {
    id: 'studio.tr0YPg',
    defaultMessage: 'Variables',
  },
  variablesDescription: {
    id: 'studio.GbN1XV',
    defaultMessage: 'Copy any variables the app has.',
  },
  secrets: {
    id: 'studio.WKtGHy',
    defaultMessage: 'Secrets',
  },
  secretsDescription: {
    id: 'studio.GyGfwz',
    defaultMessage: 'Copy any secrets the app has.\nMake sure to set their values after cloning',
  },
  cancel: {
    id: 'studio.47FYwb',
    defaultMessage: 'Cancel',
  },
  submit: {
    id: 'studio.VzzYJk',
    defaultMessage: 'Create',
  },
  cloneLoginMessage: {
    id: 'studio.Jrs+iV',
    defaultMessage:
      'In order to clone apps you must be logged in. Click <loginLink>here</loginLink> to log in using an existing account or <registerLink>here</registerLink> to register a new account.',
  },
  cloneVerifyMessage: {
    id: 'studio.4M0fNr',
    defaultMessage:
      'In order to create a new organization you must first verify your email address. Refresh the page once you have verified your email.',
  },
  cloneOrganizationInstructions: {
    id: 'studio.S6Gu8x',
    defaultMessage:
      'In order to clone an app you must be in an organization and have the permission to create new apps. You can create one below or have someone invite you to an existing organization.',
  },
});
